// document.addEventListener( 'DOMContentLoaded', function() {

	var filter_type_val = null, filter_location_val = null, filter_phase_val = null;

	if ( document.getElementById( 'types-filter-select' ) ) {
	
		var filter_type = new SlimSelect({
			select: '#types-filter-select',
			settings: {
				alwaysOpen: false,
				allowDeselect: true,
				showSearch: false
			},
			events: {
				afterChange: (newVal) => {
					if ( !newVal || !newVal.length || newVal[0].placeholder ) {
						filter_type_val = null;
					} else {
						filter_type_val = newVal[0].value;
					}
					sortProjects();
				}
			}
		});

	}


	if ( document.getElementById( 'location-filter-select' ) ) {
	
		var filter_location = new SlimSelect({
			select: '#location-filter-select',
			settings: {
				alwaysOpen: false,
				allowDeselect: true,
				showSearch: false
			},
			events: {
				afterChange: (newVal) => {
					if ( !newVal || !newVal.length || newVal[0].placeholder ) {
						filter_location_val = null;
					} else {
						filter_location_val = newVal[0].value;
					}
					sortProjects();
				}
			}
		}); 

	}
	
	if ( document.getElementById( 'phase-filter-select' ) ) {

		var filter_phase = new SlimSelect({
			select: '#phase-filter-select',
			settings: {
				alwaysOpen: false,
				allowDeselect: true,
				showSearch: false
			},
			events: {
				afterChange: (newVal) => {
					if ( !newVal || !newVal.length || newVal[0].placeholder ) {
						filter_phase_val = null;
					} else {
						filter_phase_val = newVal[0].value;
					}
					sortProjects();
				}
			}
		}); 

	}


// } );

function sortProjects() {
	// console.log(filter_type_val, filter_location_val, filter_phase_val);

	// Hide all projects
	document.querySelectorAll('.projectItem').forEach(function(el) {
		el.classList.add('d-none');
	});
	// Show projects that match the selected filters
	document.querySelectorAll('.projectItem').forEach(function(el) {
		var matchesType = !filter_type_val || el.getAttribute('data-type') === filter_type_val;
		var matchesLocation = !filter_location_val || el.getAttribute('data-location') === filter_location_val;
		var matchesPhase = !filter_phase_val || el.getAttribute('data-phase') === filter_phase_val;

		if (matchesType && matchesLocation && matchesPhase) {
			el.classList.remove('d-none');
		}
	});

}